import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import HyperDX from '@hyperdx/browser';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles/index.scss';

const {hostname} = new URL(process.env.REACT_APP_REST_API_LOCATION)

console.log({ 
  apiKey: process.env.REACT_APP_HYPERDX_API_KEY,
  service: `pyf-frontend`,
  tracePropagationTargets: [
    new RegExp(hostname, 'i')
  ], // Set to link traces from frontend to backend requests
  consoleCapture: true, // Capture console logs (default false)
  advancedNetworkCapture: true, // Capture full HTTP request/response headers and bodies (default false)
} )
HyperDX.init({ 
  apiKey: process.env.REACT_APP_HYPERDX_API_KEY,
  service: `pyf-frontend`,
  tracePropagationTargets: [
    new RegExp(hostname, 'i')
  ], // Set to link traces from frontend to backend requests
  consoleCapture: true, // Capture console logs (default false)
  advancedNetworkCapture: true, // Capture full HTTP request/response headers and bodies (default false)
});
HyperDX.setGlobalAttributes({
  appId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
